import { useLocation } from 'react-router-dom'
import { FaTimesCircle, FaBan, FaExclamationTriangle } from 'react-icons/fa'

export default function PagaleveError() {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const orderId = params.get('order_id')
  const checkoutId = params.get('checkout_id')
  const reason = params.get('reason') || 'unknown'
  const status = params.get('status')

  // eslint-disable-next-line no-console
  console.log('Pagaleve Error - Params:', { orderId, checkoutId, reason, status })

  // Determinar tipo de erro
  const getErrorConfig = () => {
    if (reason === 'canceled' || status === 'canceled') {
      return {
        icon: FaBan,
        title: 'Pagamento Cancelado',
        message: 'Você cancelou o pagamento antes de finalizar.',
        buttonText: 'Voltar ao Pagamento'
      }
    }

    if (reason === 'expired' || status === 'expired') {
      return {
        icon: FaExclamationTriangle,
        title: 'Checkout Expirado',
        message: 'O tempo para completar o pagamento expirou.',
        buttonText: 'Tentar Novamente'
      }
    }

    if (reason === 'declined' || reason === 'rejected' || status === 'declined') {
      return {
        icon: FaTimesCircle,
        title: 'Pagamento Recusado',
        message: 'O pagamento não foi aprovado pela Pagaleve.',
        buttonText: 'Escolher Outro Método'
      }
    }

    return {
      icon: FaTimesCircle,
      title: 'Erro no Pagamento',
      message: 'Ocorreu um problema ao processar seu pagamento.',
      buttonText: 'Tentar Novamente'
    }
  }

  const errorConfig = getErrorConfig()
  const Icon = errorConfig.icon

  const handleTryAgain = () => {
    if (orderId) {
      window.location.href = `/carrinho?order_id=${orderId}`
    } else {
      window.location.href = '/carrinho'
    }
  }

  const handleContinueShopping = () => {
    window.location.href = '/produtos/1'
  }

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="mx-auto w-full max-w-md rounded-xl bg-white p-8 text-center shadow-lg">
        {/* Ícone */}
        <div className="mb-6 flex justify-center">
          <Icon className="h-20 w-20 text-gray-400" />
        </div>

        {/* Título e Mensagem */}
        <h1 className="mb-4 text-3xl font-bold text-gray-800">{errorConfig.title}</h1>
        <p className="mb-6 text-lg text-gray-600">{errorConfig.message}</p>

        {/* Informações do Pedido */}
        {orderId && (
          <div className="my-6 rounded-lg bg-gray-100 p-4">
            <p className="text-sm text-gray-600">Número do Pedido</p>
            <p className="mt-1 text-xl font-bold text-gray-800">#{orderId}</p>
          </div>
        )}

        {checkoutId && (
          <div className="mb-6 text-xs text-gray-400">
            <p>ID da transação: {checkoutId.substring(0, 20)}...</p>
          </div>
        )}

        {/* Botões de Ação */}
        <div className="mt-8 flex flex-col gap-3">
          <button
            onClick={handleTryAgain}
            className="w-full rounded-lg bg-primary-700 px-6 py-3 text-base font-medium text-white transition hover:bg-primary-800">
            {errorConfig.buttonText}
          </button>

          <button
            onClick={handleContinueShopping}
            className="w-full rounded-lg border border-gray-300 bg-white px-6 py-3 text-base font-medium text-gray-700 transition hover:bg-gray-50">
            Continuar Comprando
          </button>
        </div>

        {/* Dica de Ajuda */}
        <div className="mt-6 text-xs text-gray-400">
          <p>Seu pedido está salvo. Você pode voltar a qualquer momento.</p>
          <p className="mt-2">
            Precisa de ajuda?{' '}
            <a href="mailto:suporte@cannect.com.br" className="text-primary-700 hover:underline">
              Entre em contato
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
